import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { FIELD_PATH_HEIGHT } from 'components/page/DatingProfile/DatingProfile.constants'
import { ProfileFieldType } from 'components/page/ProfileCommon/ProfileCommon.types'
import { ProfileFieldGeneric } from 'components/page/ProfileCommon/ProfileField/ProfileFieldGeneric'
import { HeightActiveSvg } from 'components/presentational/svg/HeightActiveSvg'
import { HeightDefaultSvg } from 'components/presentational/svg/HeightDefaultSvg'

export const ProfileHeight: FC<{
  data?: number | null
}> = ({ data }) => {
  return (
    <ProfileFieldGeneric
      iconDefault={<HeightDefaultSvg />}
      iconActive={<HeightActiveSvg />}
      description={
        <FormattedMessage
          id="dating_profile.height.label"
          defaultMessage="Рост"
        />
      }
      fieldType={ProfileFieldType.Height}
      data-name={FIELD_PATH_HEIGHT}
      data={data}
      showDescriptionIfActive={true}
      lexemes={null}
    />
  )
}
